var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('md-button',_vm._b({staticClass:"btn",style:(_vm.styles),attrs:{"type":_vm.type},on:{"click":_vm.callback}},"md-button",_vm._d({},[_vm.tipo,true])),[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }